const generateUniquePart = () => Math.random().toString(36).substring(2, 15)

const snackbarId = () => `${generateUniquePart()}${generateUniquePart()}`
export default snackbarId
